import { useEffect, useState } from 'react';
import { calculateCompartment, saveForestFeatures, getForestFeatures } from '../../services/projectService';
import scrollToElement from 'scroll-to-element';
import Loading from '../Loading';
import NotificationToast from '../NotificationToast';
import CompartmentList from './CompartmentList';
import Map from '../Map';
import { DroneDetailProvider, useDroneDetailContext} from '../Contexts/DroneDetailContext';
import NotificationUnsavedChanges from '../NotificationUnsavedChanges';

function ForestDetail({ projectData}) {

  const [loading, setLoading] = useState(true);
  const [areaData, setAreaData] = useState([]);
  const [pointData, setPointData] = useState([]);
  const [actionResult, setActionResult] = useState(null);
  const {setUnsavedChanges, unsavedChanges, featuresData,setFeaturesData , setDeletedFeature} = useDroneDetailContext();

  useEffect(() => {
    getForestFeatures(projectData.id)
      .then(data => {
        console.log(data);
        setFeaturesData(data);
        setPointData(data.filter(item => item.geometry.type === "Point"));
        setAreaData(data.filter(item => item.geometry.type === "Polygon"));
        setLoading(false);
        scrollToElement('#map', {
          offset: -100,
          duration: 500,
        });
      })
      .catch(error => console.error('ERR: ', error));
  }, []);


  const addFeature = (newFeature) =>{
    if (JSON.parse(newFeature.geometry).type ==="Point"){
      addTree(newFeature)
      return
    }
    addCompartment(newFeature)
  }

  const addTree = (newFeature) => {
    const tree = {
      properties: {
        epsg: projectData.epsg,
        label:newFeature.label,
        id:newFeature.id
      },
      type: "Feature",
      geometry: JSON.parse(newFeature.geometry)
    }
    setFeaturesData(prev => [...prev, tree])
    setUnsavedChanges(true);
  }

  const addCompartment = (newFeature) => {
    console.log(newFeature);
    compartmentCalculation({
      properties: {
        id: newFeature.featureId,
        id_project: projectData.id,
        epsg: projectData.epsg
      },
      type: "Feature",
      geometry: JSON.parse(newFeature.geometry)
    })
  }

  const compartmentCalculation = (compartment) => {
    calculateCompartment(compartment)
      .then(data => {
        compartment.properties = {
          data: data,
          id: compartment.properties.id
        }
        setFeaturesData(prev => [...prev, compartment])
      }
      )
  }

  const removeCompartment = ({ item, idx }) => {
    console.log(item)
    setUnsavedChanges(true);
     setDeletedFeature(item);
  }
  const handleSaveForestFeatures = () => {
    console.log(featuresData)
    saveForestFeatures(featuresData, projectData.id)
      .then(() => {
        setUnsavedChanges(false);
        setActionResult({
          kind: 'success',
          message: 'Data has been successfully saved.'
        });
      })
      .catch(() => {
        setActionResult({
          kind: 'error',
          message: 'An error has occurred while saving data'
        });
      });
  }

  return (
    <>
      <NotificationUnsavedChanges
        isOpen={unsavedChanges}
        onSave={handleSaveForestFeatures}/>

      <NotificationToast
        toastId="forestDetail"
        kind={actionResult?.kind}
        message={actionResult?.message}
        onClose={() => setActionResult(null)}
      />
      {loading ? (<Loading message="forest loading" />) : (
        <>
          <Map projectData = {projectData}
            lineData={[]}
            areaData={areaData}
            pointData={pointData}
            addFeature={addFeature}
          />
          <CompartmentList data={featuresData.filter(f=>f.geometry.type==="Polygon")} onDelete={removeCompartment} />
        </>
      )}
    </>
  );
}

export default function DroneDetailWithContext({projectData}) {
  return (
    <DroneDetailProvider>
      <ForestDetail projectData={projectData}/>
    </DroneDetailProvider>
  );
};